import styled from "styled-components";
import { useEffect, useState } from "react";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import goTo from "../../../../controllers/goTo";
import MaterialInput from "../../../helperComponents/MaterialInput";
import DropDownInput from "../../../helperComponents/DropDownInput";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import getUrlQuery from "../../../../controllers/getUrlQuery";
import ImagePicker from "../../../editors/ImagePicker";
import MapWithDraggableMarker2 from "../../../map/MapWithDraggableMarker2";
import contentPurposes from "../../../../data/contentPurposeTypes";
import CustomCheckbox from "../../../helperComponents/CustomCheckbox";
import DropDownLocationInput from "../../../helperComponents/DropDownLocationInput";
import PrimaryButton from "../../../helperComponents/PrimaryButton";
import ngoTypes from "../../../../data/ngoTypes";
import CustomButton from "../../../helperComponents/CustomButton";
import { GoLocation } from "react-icons/go";
import getGpsLocation from "../../../../controllers/customKarunaController/getGpsLocation";

const initialLocation = { lat: 23.398831924485105, lng: 78.19784084625248 };

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  /* margin-top: 100px; */
  align-items: center;
`;

const Inputs = styled.div`
  border-radius: 10px;
  display: flex;
  width: 600px;
  flex-direction: column;
  align-items: center;
  gap: 30px;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const InputItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px;
  gap: 20px;
  width: 100%;
  border-radius: 15px;
  background-color: var(--surface3);
  border: 1px solid var(--borderDim);
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 15px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const Buttons = styled.div`
  width: 38vw;
  /* background-color: red; */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
`;

const MapSection = styled.div`
  width: 100%;
  height: 500px;
  border-radius: 15px;
  overflow: hidden;
`;

let dropDownStyle = { flex: 1 };

export default function AddOrEditContent({}) {
  const [itemId, setItemId] = useState(null);
  const [item, setItem] = useState({ images: [] });
  const [loading, setLoading] = useState(false);
  const [actionType, setActionType] = useState("ADD");
  const [forcedMapUpdateCode, setForcedMapUpdateCode] = useState("random123");

  console.log("item", item);

  useEffect(() => {
    let newitemId = getUrlQuery("itemId");
    setItemId(newitemId);

    if (newitemId) setActionType("UPDATE");
  }, []);

  useEffect(() => {
    if (actionType == "UPDATE") {
      setLoading(true);
      if (itemId) {
        loadItemToBeEdited();
      }
    } else {
      let newItem = { ...item };

      let defaultPurpose = getUrlQuery("defaultPurpose");

      if (defaultPurpose) {
        newItem["purpose"] = defaultPurpose;
      }

      newItem.latitude = initialLocation.lat;
      newItem.longitude = initialLocation.lng;

      setItem(newItem);
    }
  }, [itemId]);

  let titleLine1 = "Create";
  let titleLine2 = "Post";

  if (actionType == "UPDATE") {
    titleLine1 = "Edit";
    titleLine2 = "Post";
  }

  if (loading) {
    return (
      <LoggedInBoilerplate
        showBackButton={true}
        titleLine1={titleLine1}
        titleLine2={titleLine2}
      >
        <LoadingSection />
      </LoggedInBoilerplate>
    );
  }

  return (
    <LoggedInBoilerplate
      showBackButton={true}
      titleLine1={titleLine1}
      titleLine2={titleLine2}
    >
      <Container>
        <Inputs>
          <UploadSection>
            <ImagePicker
              forPerson={true}
              value={item.images[0]}
              onChange={(newValue) => {
                updateField("images", true)([newValue]);
              }}
            ></ImagePicker>
          </UploadSection>

          <InputItems>
            <Row>
              <MaterialInput
                label={"Title"}
                multiline={true}
                rows={2}
                value={item.title}
                onChange={updateField("title")}
              />
            </Row>

            <Row>
              <MaterialInput
                multiline={true}
                rows={15}
                label={"Description"}
                value={item.description}
                onChange={updateField("description")}
              />
            </Row>
          </InputItems>

          <InputItems>
            <Row>
              <DropDownLocationInput
                type="STATE"
                country="IN"
                value={item.state}
                onChange={updateField("state", true)}
              />

              <DropDownLocationInput
                country="IN"
                type="CITY"
                state={item.state}
                value={item.city}
                onChange={updateField("city", true)}
              />
            </Row>
            <Row>
              <DropDownInput
                options={contentPurposes}
                label="Purpose"
                value={item.purpose}
                onChange={updateField("purpose", true)}
              />

              <DropDownInput
                options={ngoTypes}
                label="Type"
                value={item.type}
                onChange={updateField("type", true)}
              />

              <CustomCheckbox
                label="Show Map"
                value={item.hasLatLong}
                onChange={updateField("hasLatLong", true)}
              />
            </Row>
          </InputItems>

          {item.hasLatLong ? (
            <>
              <MapSection>
                <MapWithDraggableMarker2
                  forcedMapUpdateCode={forcedMapUpdateCode}
                  value={getLocationValue()}
                  onChange={(newVal) => {
                    setItem((existingItem) => {
                      existingItem = { ...existingItem };
                      existingItem.latitude = newVal.lat;
                      existingItem.longitude = newVal.lng;

                      return existingItem;
                    });
                  }}
                />
              </MapSection>

              <InputItems>
                <Row>
                  <MaterialInput
                    type="number"
                    label={"Latitude"}
                    value={parseFloat(item.latitude)}
                    onChange={updateField("latitude")}
                  />

                  <MaterialInput
                    type="number"
                    label={"Longitude"}
                    value={parseFloat(item.longitude)}
                    onChange={updateField("longitude")}
                  />

                  <CustomButton onClick={useMyLocation} icon={<GoLocation />}>
                    Use My Current Location
                  </CustomButton>
                </Row>
              </InputItems>
            </>
          ) : null}

          <br />
          <Buttons>
            <PrimaryButton style={{ minWidth: "250px" }} onClick={save}>
              {actionType == "UPDATE" ? "Modify Post" : "Create Post"}
            </PrimaryButton>
          </Buttons>
        </Inputs>
      </Container>
    </LoggedInBoilerplate>
  );

  function useMyLocation() {
    getGpsLocation(({ latitude, longitude }) => {
      setItem((newItem) => {
        newItem = { ...newItem };
        newItem["latitude"] = latitude;
        newItem["longitude"] = longitude;
        console.log("lat", "long", latitude, longitude);
        return newItem;
      });

      setTimeout(() => {
        setForcedMapUpdateCode(Math.random() * 1000);
      }, 500);
    });
  }

  function updateField(fieldName, dontUseEventValue) {
    return (e) => {
      setItem((newItem) => {
        newItem = { ...newItem };
        if (dontUseEventValue) {
          newItem[fieldName] = e;
        } else {
          newItem[fieldName] = e.target.value;
        }

        return newItem;
      });

      setTimeout(() => {
        if (fieldName == "latitude" || fieldName == "longitude") {
          setForcedMapUpdateCode(Math.random() * 1000);
        }
      }, []);
    };
  }

  function getLocationValue() {
    if (!item.latitude) return initialLocation;
    if (!item.longitude) return initialLocation;

    let lat = parseFloat(item.latitude);
    let lng = parseFloat(item.longitude);

    if (isNaN(lat)) return initialLocation;
    if (isNaN(lng)) return initialLocation;

    return { lat: lat, lng: lng };
  }

  function save() {
    if (actionType == "UPDATE") editItem();
    if (actionType == "ADD") createItem();
  }

  async function loadItemToBeEdited() {
    let data = await serverLine.get(`/content/?itemId=${itemId}`);

    setItem(data);
    setLoading(false);
  }

  async function createItem() {
    setLoading(true);

    try {
      let res = await serverLine.post("/content", {
        images: item.images,
        title: item.title,
        type: item.type,
        purpose: item.purpose,
        description: item.description,
        longitude: item.longitude,
        latitude: item.latitude,
        hasLatLong: item.hasLatLong,
        state: item.state,
        city: item.city,
      });

      window.popupAlert(res.message);
      goTo(`/p/${res.item._id}`)();
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }

  async function editItem() {
    setLoading(true);

    try {
      let res = await serverLine.patch("/content", {
        itemId,
        changes: {
          images: item.images,
          title: item.title,
          type: item.type,
          purpose: item.purpose,
          description: item.description,
          longitude: item.longitude,
          latitude: item.latitude,
          hasLatLong: item.hasLatLong,
          state: item.state,
          city: item.city,
        },
      });

      window.popupAlert(res.message);
      goTo(`/p/${res.item._id}`)();
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }
}
